<div class="flex h-full w-full flex-col gap-4 pb-6 sm:pb-10">
  <div
    class="flex w-full items-center justify-end gap-2 rounded-2xl border border-gray-200 bg-white p-2"
  >
    <div class="flex items-center">
      <button
        mat-icon-button
        class="p-button-outlined h-full self-center hover:cursor-pointer"
        (click)="this.builderStatusService.togglePlaying()"
      >
        <mat-icon svgIcon="heroicons_outline:stop"></mat-icon>
      </button>
    </div>
  </div>
  <div
    class="mx-auto grid h-full w-full max-w-screen-lg grid-cols-[20rem_1fr] gap-4 overflow-hidden"
  >
    @let module = forms.moduleStructure();
    @if (forms.ready() && module) {
      <div class="flex w-full flex-col gap-2">
        <lib-card>
          <ng-container title> Sezioni</ng-container>
          <ng-container content>
            <div class="flex flex-1 flex-col gap-6 overflow-y-auto py-4">
              <ul class="flex w-full flex-row justify-between gap-2">
                <li class="flex-1">
                  <span
                    [ngClass]="
                      this.sectionId() === 'applicant' ? 'font-semibold' : ''
                    "
                    class="hover:cursor-pointer"
                    (click)="this.first.set(0)"
                    >Dati del candidato
                  </span>
                </li>
              </ul>
              @for (
                section of module.root.children;
                track $index;
                let i = $index
              ) {
                <ul class="w-full">
                  @let moduleSection = module[section];
                  @if (moduleSection._type === 'section') {
                    <li>
                      <div class="flex justify-between gap-2">
                        <span
                          [ngClass]="
                            section === this.sectionId() ? 'font-semibold' : ''
                          "
                          class="hover:cursor-pointer"
                          (click)="this.first.set($index + 1)"
                        >
                          {{ moduleSection.customization.title }}
                        </span>

                        <span
                          class="w-16 text-end"
                          [ngClass]="
                            section === this.sectionId() ? 'font-semibold' : ''
                          "
                          >{{ moduleSection.customization.points }} pt</span
                        >
                      </div>
                    </li>

                    <li>
                      <ul class="ml-6 list-disc flex-row justify-between gap-2">
                        @for (
                          subsection of moduleSection.children;
                          track subsection;
                          let j = $index
                        ) {
                          @let moduleSubSection = module[subsection];
                          @if (
                            moduleSubSection._type === 'subsection' &&
                            moduleSubSection.customization.title !== ''
                          ) {
                            <li
                              class="cursor-pointer hover:underline"
                              (click)="loadAndFocus(i, subsection)"
                            >
                              <div class="flex justify-between gap-2">
                                {{ moduleSubSection.customization.title }}

                                <span class="w-16 text-end"
                                  >{{
                                    moduleSubSection.customization.points
                                  }}
                                  pt</span
                                >
                              </div>
                            </li>
                          }
                        }
                      </ul>
                    </li>
                  }
                </ul>
              }
            </div>
          </ng-container>
        </lib-card>
      </div>
      <div class="flex h-full min-h-0 w-full flex-col gap-2 overflow-y-auto">
        @let sectionId = this.sectionId();
        @if (sectionId) {
          <form class="flex w-full flex-col gap-2 rounded-2xl bg-white">
            <lib-compiling-section [uniqueId]="sectionId" />
            <p-paginator
              (onPageChange)="onPageChange($event)"
              [first]="first()"
              [rows]="1"
              [totalRecords]="module.root.children.length"
              [showCurrentPageReport]="true"
              [showPageLinks]="false"
              [showJumpToPageDropdown]="false"
              [showFirstLastIcon]="false"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              class="rounded-2xl"
            />
          </form>
        }
      </div>
    }
  </div>
</div>
